<template>
    <div class="input-group">
        <input
            type="text"
            class="form-control border-end-0"
            placeholder="Search Contact"
            :value="searchStore.searchTerm"
            @input="update(($event.target as HTMLInputElement).value)"
            v-focus
        />
        <span class="input-group-append">
            <div class="input-group-text bg-transparent px-2">
                <i class="fas fa-search dialog-close text-secondary font-size-sm"></i>
            </div>
        </span>
    </div>
</template>
<script lang="ts" src="./CallSearch.ts"></script>
